import { defineComponent as _defineComponent } from 'vue'
import WizardStep from '@/components/wizard/WizardStep.vue';
import { useI18n } from '@/composables/i18n';
import { ConsoleEnum } from '@/models/enums/ConsoleEnum';
import { Location } from '@/models/location';
import { User } from '@/models/user';
import { UserType } from '@/models/userType';
import { locationsService } from '@/services/locations.service';
import { isEmpty } from '@/utils/misc';
import { currentUser, hasCurrentUserPermission } from '@/utils/permissionUtils';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PermissionsWizardStep',
  props: {
    value: null,
    hidden: { type: Boolean },
    isEdit: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: User) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: User;
  /**
   * `true` to hide the step
   */
  hidden: boolean;
  /**
   * `true` to set the form in edition mode
   */
  isEdit: boolean;
};





const customerLocations = ref<Location[]>([]);
const isLoading = ref(false);

const { t } = useI18n();

const availableUserTypes = [UserType.CustomerUser, UserType.CustomerAdmin];

async function loadLocations() {
  if (!userHasEnabledWCC.value) {
    return;
  }
  isLoading.value = true;
  try {
    customerLocations.value = await locationsService.get(
      props.value.customerId,
    );
  } finally {
    isLoading.value = false;
  }
}

function onInput() {
  emit('input', props.value);
}

const userHasEnabledWCC = computed(() =>
  props.value.consoles.includes(ConsoleEnum.WCC),
);

const userTypeIsNone = computed(() => props.value.userType === UserType.None);

const isEditingUser = computed(() => props.value.id > 0);

const userTypeDisabled = computed(
  () =>
    isEditingUser.value &&
    !(currentUser().isGlobalAdmin || currentUser().isSubsidiaryAdmin),
);

/**
 * **Global and Subsidiary Admin:** can always edit Customer Admin/User locations
 *
 * **Customer Admin:** can only edit Customer Admin/User locations when creating the user (not editing it)
 */
const canEditLocations = computed(
  () => !props.isEdit || hasCurrentUserPermission(UserType.SubsidiaryAdmin),
);

return { __sfc: true,props, emit, customerLocations, isLoading, t, availableUserTypes, loadLocations, onInput, userHasEnabledWCC, userTypeIsNone, isEditingUser, userTypeDisabled, canEditLocations, WizardStep, isEmpty }
}

})